import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import { mq } from '@sthzg/sthzgnet-base';

const isFirst = idx => idx === 0;
const isLast = (idx, list) => list.length === idx + 1;

const Headline = styled.h1`
  margin-top: 0;
`;

const boxStyle = props => css`
  display: inline-block;
  margin-top: ${props.isFirst ? '0' : '6px'};
  margin-bottom: ${props.isLast ? '0' : '6px'};
  ${mq.small(css`
    display: block;
    margin-top: ${props.isFirst ? '0' : '15px'};
    margin-bottom: ${props.isLast ? '0' : '15px'};
  `)};
`;

const Box = styled.span`
  ${props => boxStyle(props)};
`;

Box.propTypes = {
  isFirst: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
};

const Token = styled.span`
  padding: 5px;
  background: white;
`;

const StripedHeadline = ({ className, tokens }) => (
  <Headline className={className}>
    {tokens.map((token, idx) => (
      <Box isFirst={isFirst(idx)} isLast={isLast(idx, tokens)} key={token}>
        <Token>{token}</Token>
      </Box>
    ))}
  </Headline>
);

StripedHeadline.propTypes = {
  className: PropTypes.string,
  tokens: PropTypes.arrayOf(PropTypes.string).isRequired,
};
StripedHeadline.defaultProps = {
  className: null,
};

export default StripedHeadline;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/StripedHeadline/StripedHeadline.jsx